import React from "react";

import { ArticlePageChooserBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Clickable } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./ArticleCard.module.scss";

interface Props {
    article: ArticlePageChooserBlock;
}

export const ArticleCard = ({ article }: Props) => {
    return (
        <Clickable href={article.url} className={styles.article}>
            {article.featured_image ? (
                <ImageChooserBlock
                    value={article.featured_image}
                    attrs={{ className: styles.image }}
                />
            ) : (
                <div className={styles.placeholder}>
                    <Svg name="logo-monogram" />
                </div>
            )}
            {article.tags && article.tags.length > 0 && (
                <div className={styles.badge}>
                    <span>{article.tags[0]}</span>
                </div>
            )}
            <h3 className={styles.title}>{article.title}</h3>
        </Clickable>
    );
};
